import { render, staticRenderFns } from "./UpdateContentTrainers.vue?vue&type=template&id=1e031646&scoped=true&"
import script from "./UpdateContentTrainers.vue?vue&type=script&lang=js&"
export * from "./UpdateContentTrainers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../Github/lmsv4_web_frontend_vue/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e031646",
  null
  
)

export default component.exports